import React from 'react';
import { Card, Typography, withStyles } from '@material-ui/core';
import { withModal } from '~/components/PF2MModal';
import { ModalPropTypes } from '~/components/PF2MModal/withModal';
import { useTranslation } from 'react-i18next';
import { CardBody, CardHeader, CardIcon } from '~/components/Card';
import CloseIcon from '@material-ui/icons/Close';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './styles';

const PF2MValidationModal = React.forwardRef(({
  closeModal,
  classes,
  description,
}, _ref) => {
  const { t: translate } = useTranslation();

  return (
    <Card className={classes.modal}>
      <CardHeader icon>
        <div>
          <CardIcon
            onClick={closeModal}
            style={{
              float: 'right',
              cursor: 'pointer',
              background: '#F6F5EE',
              border: '2px solid #111110',
              boxShadow: 'none',
              color: '#111110',
              borderRadius: 50,
            }}
          >
            <CloseIcon />
          </CardIcon>
        </div>
      </CardHeader>
      <Typography variant="h4" align="center" className={classNames(classes.cardTitle, classes.modalTitle)}>
        {translate('common:DispatchModule')}
      </Typography>
      <CardBody className={classes.modalBody}>
        <div>
          <Typography className={classes.modalText}>
            {description}
          </Typography>
        </div>

        <div style={{ margin: 40 }} />
      </CardBody>
    </Card>
  );
});

PF2MValidationModal.propTypes = {
  ...ModalPropTypes,
  description: PropTypes.string,
};

PF2MValidationModal.defaultProps = {
  description: '',
};

export default withModal(withStyles(styles)(PF2MValidationModal));
